@let notes = (notes$ | async)!;
<p-drawer [(visible)]="notificationsSidebarVisible" [closable]="false" position="right" styleClass="w-120!">
  <ng-template #header>
    <h3 class="m-0 mb-4 flex w-full justify-between gap-1 p-0 pr-4 font-bold">
      {{ 'chat.pendingNotifications' | translate | titlecase }}
      <p-tag [value]="$any(notes.length)" [rounded]="true">
        <ng-template #icon>
          <fa-icon [icon]="faBell"></fa-icon>
        </ng-template>
      </p-tag>
    </h3>
  </ng-template>

  @if (notes.length > 0) {
    <ul class="m-0 list-none p-0">
      @for (note of notes; track note; let index = $index) {
        @if (showDayDivider(notes[index - 1], note)) {
          <li class="m-0 mb-2 p-0 text-center">
            {{ $safeNavigationMigration(note?._metadata?.created) | date: 'longDate' }}
          </li>
        }
        <li
          class="group m-0 mb-2 rounded-sm border border-[#dee2e6] p-2! hover:cursor-pointer hover:bg-[rgb(223,223,223)]"
          (mouseenter)="onNoteMouseEnter(note)"
          (mouseleave)="onNoteMouseLeave(note)"
        >
          <button
            type="button"
            class="block w-full cursor-pointer border-0 bg-transparent p-0 text-left"
            (click)="goTo(note)"
          >
            <span class="flex items-center justify-between gap-2 pr-1">
              <span class="metadata">
                <span>
                  <b>{{ note?._metadata?.creator }}</b>
                  {{ ' ' }}
                  <i>{{ $safeNavigationMigration(note?._metadata?.created) | date: 'shortTime' }}</i>
                </span>
              </span>
              <fa-icon [icon]="getIconByCollection(note.collectie)"></fa-icon>
            </span>
            <span
              class="block overflow-hidden text-ellipsis whitespace-nowrap transition-[height] duration-500 ease-in-out group-hover:overflow-visible group-hover:whitespace-normal motion-reduce:duration-[1ms]"
              [class.h-auto]="notesAnimationState.get(note.id)"
              [class.h-6]="!notesAnimationState.get(note.id)"
            >
              {{ note.bericht }}
            </span>
          </button>
          <footer
            class="hidden items-center justify-end gap-2 overflow-hidden transition-[height] duration-200 ease-in-out group-hover:flex motion-reduce:duration-[1ms]"
            [class.h-auto]="notesAnimationState.get(note.id)"
            [class.h-0]="!notesAnimationState.get(note.id)"
          >
            <p-checkbox
              [pTooltip]="'chat.readHelp' | translate"
              [binary]="true"
              inputId="readed"
              class="p-checkbox-sm"
              (onChange)="markAsRead($event, note)"
            ></p-checkbox>
          </footer>
        </li>
      }
    </ul>
  } @else {
    <span>{{ 'chat.noPendingNotifications' | translate }}</span>
  }
</p-drawer>
